module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img2.abd1dabab45a0cec45c731f1e6c77902.jpg";